import React from 'react';
import { Link } from 'react-router-dom';
import {
  ArrowRight, Globe, Plane, Ship, Truck, Handshake,
  Network, MapPin
} from 'lucide-react';
import Hero from '../components/Hero';
import './GlobalNetwork.css';

const GlobalNetwork = () => {
  const capabilities = [
    { icon: Handshake, title: 'Global Logistics Partners', desc: 'A strong network of trusted partners across the world.' },
    { icon: Network, title: 'JCtrans Network', desc: 'Access to a wide network of verified logistics partners in 100+ countries.' },
    { icon: Plane, title: 'International Air Freight', desc: 'Reliable air freight connections to major destinations worldwide.' },
    { icon: Ship, title: 'Worldwide Sea Freight', desc: 'Extensive ocean freight services across all key trade routes.' },
    { icon: Truck, title: 'Cross-Border Transportation', desc: 'Efficient road and multimodal solutions across borders.' },
    { icon: MapPin, title: 'End-to-End Logistics Solutions', desc: 'Comprehensive logistics support tailored to your business needs.' },
  ];

  return (
    <div className="global-network">
      <Hero
        label="Global Network"
        title="Global Network & Partnerships"
        subtitle="Connecting businesses across global trade lanes."
        size="medium"
        image="/img/global-network-hero.jpg"
      />

      <section className="section network-intro">
        <div className="container">
          <div className="network-intro__grid">
            <div className="network-intro__content">
              <span className="section-label">Our Reach</span>
              <h2 className="section-title">Connecting Businesses Across Global Trade Lanes</h2>
              <p>
                Through our association with JCtrans and our network of trusted international
                logistics partners, Denver Logistics connects customers to reliable logistics
                solutions across major global markets.
              </p>
              <p>
                Our international network enables efficient coordination, responsive communication,
                and end-to-end shipment support.
              </p>
              <Link to="/contact" className="btn btn-outline" style={{ marginTop: '16px' }}>
                Connect With Us <ArrowRight size={16} />
              </Link>
            </div>
            <div className="network-intro__map">
              <div className="network-map">
                <Globe size={180} strokeWidth={0.3} className="network-map__globe" />
                <div className="network-map__points">
                  <span className="network-map__point" style={{ top: '25%', left: '15%' }} title="Americas" />
                  <span className="network-map__point" style={{ top: '30%', left: '45%' }} title="Europe" />
                  <span className="network-map__point" style={{ top: '35%', left: '55%' }} title="Middle East" />
                  <span className="network-map__point network-map__point--home" style={{ top: '45%', left: '65%' }} title="India" />
                  <span className="network-map__point" style={{ top: '30%', left: '75%' }} title="East Asia" />
                  <span className="network-map__point" style={{ top: '40%', left: '82%' }} title="Southeast Asia" />
                  <span className="network-map__point" style={{ top: '65%', left: '48%' }} title="Africa" />
                  <span className="network-map__point" style={{ top: '70%', left: '80%' }} title="Oceania" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section network-capabilities">
        <div className="container">
          <div className="text-center">
            <span className="section-label">Our Capabilities</span>
            <h2 className="section-title">How We Connect You Globally</h2>
          </div>
          <div className="network-capabilities__grid">
            {capabilities.map((cap, index) => (
              <div key={index} className="network-cap-card">
                <div className="network-cap-card__icon">
                  <cap.icon size={28} />
                </div>
                <h3 className="network-cap-card__title">{cap.title}</h3>
                <p className="network-cap-card__desc">{cap.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section network-cta">
        <div className="container">
          <div className="network-cta__inner">
            <h2>Local Expertise. Global Reach. One Trusted Logistics Partner.</h2>
            <p>Partner with Denver Logistics for reliable global connectivity and supply chain solutions.</p>
            <Link to="/quote" className="btn btn-white btn-lg">
              Get a Quote <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GlobalNetwork;
